"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n    margin-left: 0;\n    margin-bottom: ",
        ";\n    font-size: rem(18px);\n    background-color: var(--",
        ");\n    padding: ",
        ";\n    border-radius: 8px;\n    color: var(--text-default);\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var BoxWithIcon = function(param) {
    var children = param.children, bgColor = param.bgColor, dataTestId = param["data-testid"], _param_hasNoPadding = param.hasNoPadding, hasNoPadding = _param_hasNoPadding === void 0 ? false : _param_hasNoPadding, _param_hasNoMargin = param.hasNoMargin, hasNoMargin = _param_hasNoMargin === void 0 ? false : _param_hasNoMargin;
    var StyledDiv = _styled.default.div(_templateObject(), hasNoMargin ? "0" : "32px", bgColor, hasNoPadding ? "0" : "16px 24px 16px 24px");
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(StyledDiv, {
        "data-testid": dataTestId,
        children: children
    });
};
var _default = BoxWithIcon;
